import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from "react-router-dom";


const PREFIX = 'SureYouWantToCancel';

const classes = {
  button: `${PREFIX}-button`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.button}`]: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  }
}));

export default function SureYouWantToCancel() {
  const [open, setOpen] = React.useState(false);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Root>
      <Button
  className={`button-tertiary ${classes.button}`}
  onClick={handleClickOpen}
>
  Cancel
</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Leave this page?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            If you leave, your current progress will not be saved. 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} >
            cancel
          </Button>
          <Button onClick={handleClose} component={Link} to="/create-study" autoFocus>
            yes, i want to leave
          </Button>
        </DialogActions>
      </Dialog>
    </Root>
  );
}